import config from '../config';

export interface UpdateUserRoutingProfileRequest {
  userIds: string[];
  routingProfileId: string;
}

export interface UpdateUserRoutingProfileResult {
  userId: string;
  success: boolean;
  error?: string;
}

export interface UpdateUserRoutingProfileResponse {
  results: UpdateUserRoutingProfileResult[];
  totalRequested: number;
}

export const updateUserRoutingProfile = async (
  request: UpdateUserRoutingProfileRequest
): Promise<UpdateUserRoutingProfileResponse> => {
  const apiUrl = config.catoApiUrl;

  if (!apiUrl) {
    throw new Error('Agent Allocation API Url is not configured');
  }

  const url = `${apiUrl}/user-routing-profile`;

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request)
  });

  if (!response.ok) {
    throw new Error(`Failed to update user routing profile: ${response.status} ${response.statusText}`);
  }

  const data = (await response.json()) as UpdateUserRoutingProfileResponse;
  return data;
};
